import React from 'react';

const PrivacyPage: React.FC = () => {
  return (
    <div className="page legal-page">
      <section className="page-heading">
        <div>
          <p className="eyebrow">Privacy policy</p>
          <h1>What this version of Snake Game stores.</h1>
          <p>
            This page explains the types of information used to personalize gameplay, account
            experiences, rankings, and sharing features.
          </p>
        </div>
      </section>

      <section className="legal-grid">
        <article className="legal-card">
          <h2>Profile data</h2>
          <p>
            If you create a profile, the nickname, email, tagline, and preferred mode or skin may
            be used to personalize the experience and display your identity across the site.
          </p>
        </article>

        <article className="legal-card">
          <h2>Gameplay data</h2>
          <p>
            Scores, mode selections, and selected skins may be used to maintain preferences,
            rankings, and overall gameplay continuity.
          </p>
        </article>

        <article className="legal-card">
          <h2>Sharing</h2>
          <p>
            Invite links and sharing actions may use browser or operating-system sharing tools to
            help you send challenges and links to other players.
          </p>
        </article>

        <article className="legal-card">
          <h2>Deleting data</h2>
          <p>
            You can remove account and gameplay data associated with the site through the storage
            and privacy controls provided by your browser environment.
          </p>
        </article>
      </section>
    </div>
  );
};

export default PrivacyPage;
